import { useEffect, useLayoutEffect } from 'react';
import { useSidebar } from '../contexts/SidebarContext';
import { useEnhancedAuth } from '../contexts/EnhancedAuthContext';

type TabType = 'overview' | 'guides' | 'news' | 'resources' | 'templates' | 'legislation' | 'updates';

export const useEducationHubSidebar = (defaultTab: TabType = 'overview') => {
  const { setItems, setActiveItem, setFooterItems } = useSidebar();
  const { handleLogout } = useEnhancedAuth();

  const tabConfig = [
    { id: 'overview' as TabType, label: 'Overview', icon: '🏠' },
    { id: 'guides' as TabType, label: 'Guides', icon: '📖' },
    { id: 'news' as TabType, label: 'News', icon: '📰' },
    { id: 'resources' as TabType, label: 'Resources', icon: '📚' },
    { id: 'templates' as TabType, label: 'Templates', icon: '📋' },
    { id: 'legislation' as TabType, label: 'Legislation', icon: '📜' },
    { id: 'updates' as TabType, label: 'Updates', icon: '🔄' }
  ];

  const footerConfig = [
    { id: 'help', label: 'Help', to: '/ContactUs', icon: '⁉️' },
    { id: 'privacy', label: 'Privacy Policy', to: '/PrivacyPolicy', icon: '⛓️‍💥' },
    { id: 'logout', label: 'Logout', onClick: () => { handleLogout() }, icon: '💤' }
  ];

  useLayoutEffect(() => {
    setItems(tabConfig);
    setFooterItems(footerConfig);
    setActiveItem(defaultTab);
    // eslint-disable-next-line
  }, [setItems, setFooterItems, setActiveItem, defaultTab]);
};
